<script>
import CustomersApi from "@/services/customers-api";
import Swal from "sweetalert2";
import i18n from "../../../i18n";
import BackOrdersApi from "@/services/backOrders-api";
import OrderModal from "@/components/orderModal"
import {Priviliges} from "../../../privileges";

/**
 * Carts-list component
 */
export default {

  mounted(){
    this.role=sessionStorage.getItem("userr");
    if(this.role==1){
      this.getCustomers()
    }
    if(sessionStorage.getItem("privileges")!=null){
        this.privileges=sessionStorage.getItem("privileges")
        this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
        this.hasBackOrderCancelAccess=this.privileges.includes(Priviliges[0]["BackOrder_Cancel"] )
    }
    this.findBackOrders()

  },

  components: { OrderModal},
  data() {
    return {
        selected:null,
        role:null,
        customersList:[],
        selectedCustomer:null,
        isTableLoading:false,
        itemsList:[],
        itemsListFieldsForSupplier: [
            { key:"creationDateStr", thClass:"text-left", tdClass:"text-left "},
            { key:"customerName", thClass:"text-left", tdClass:"text-left font-weight-bold"},
            { key:"itemRef", thClass:"text-left", tdClass:"text-left  font-weight-bold "},
            { key:"itemTitle", thClass:"text-left d-md-table-cell d-none", tdClass:"text-left  font-weight-bold d-md-table-cell d-none"},
            { key:"discountedPrice",label:"", thClass:"text-right ", tdClass:"text-right "},
            { key:"quantity", label:"", thClass:"text-right", tdClass:"text-right font-weight-bold "},
            { key:"action",label:"",thClass:"text-center", tdClass:"text-center align-middle"},
        ],
        itemsListFieldsForCustomer: [
            { key:"selection",label:"",thClass:"text-center", tdClass:"text-center"},
            { key:"creationDateStr", thClass:"text-left", tdClass:"text-left font-weight-bold"},
            { key:"itemRef", thClass:"text-left", tdClass:"text-left  font-weight-bold  "},
            { key:"itemTitle", thClass:"text-left d-md-table-cell d-none", tdClass:"text-left  font-weight-bold d-md-table-cell d-none"},
            { key:"discountedPrice",label:"", thClass:"text-right", tdClass:"text-right "},
            { key:"quantity", label:"", thClass:"text-right", tdClass:"text-right  font-weight-bold "},
            { key:"action",label:"",thClass:"text-center", tdClass:"text-center align-middle"},
        ],
        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
        selectedBackOrders:new Set(),
        order: {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0},   
        optionsPriorities: [
            { value: 0, name: 'Basse : veuillez selectionner la date de livraison souhaitée' },
            { value: 1, name: "Normale : livraison J+1" },
            { value: 2, name: "Urgente: livraison le jour même"  },
          ],
        selectedPriority: { value: 1, name: 'Normale : livraison J+1' },
        promotionCode:null,
        orderMessage:'',
        desiredDeliveryDate:null,
        optionsDeliveryAddresses: [],
        selectedDeliveryAddress: null,
        isSubmittingOrder:false,
        showOrdersDetailsModal:false,
        showAlert:false,
        refFilter:null,
        privileges:"",
        isAdmin:false,
        hasBackOrderCancelAccess :false,
    };
  }, 
  methods:{
    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
        response => {
          this.customersList=response;
        }
      )
    },

    findBackOrders() {
      this.isTableLoading = true;
      BackOrdersApi.getBackOrders(this.pagemodel.currentPage, this.pagemodel.perPage,this.refFilter,this.selectedCustomer).then(
          (result)=>{
              if(result){
                this.itemsList = result.list
                this.pagemodel.totalRows = result.total;
                this.pagemodel.currentPage = result.page;
                this.pagemodel.perPage = result.pageSize;
                this.pagemodel.pageSize = result.pageSize;
                var varSelectedBackOrders = this.selectedBackOrders 
                this.itemsList.forEach(function(item){
                    item.edit = false;
                    if(varSelectedBackOrders.has(item.id)){
                        item.selected=1
                    }else{
                        item.selected=0
                    }
                });
              }
          }
      ).finally(
          ()=>{
            this.isTableLoading = false
          }
      )

      },

      cancelBackOrder(line){
        Swal.fire({
            title: i18n.t("cartTab.cancelBackOrder.swal.title"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f46a6a",
            cancelButtonColor: "#34c38f",
            cancelButtonText: i18n.t("cartTab.cancelBackOrder.swal.cancelButtonText"),
            confirmButtonText: i18n.t("cartTab.cancelBackOrder.swal.confirmButtonText")
        })
        .then(result => {
            if (result.value) {

            BackOrdersApi.cancelBackOrder(line==null ? null : line.id)
                .then((result) => {
                        if (result) {
                            this.findBackOrders()
                        } 
                })
            }
        });

      },

    editBackOrderQuantity(item) {
      item.edit=true;

      let input = this.$refs['confirmedQuantityEdit-' + item.id];
      input.focus();
    },

    saveBackOrderQuantity(line){
        BackOrdersApi.saveBackOrderQuantity(line==null ? null :line.id,line.quantity).then(
            (result)=>{
                if(result){
                    line.edit=false;
                    this.findBackOrders()
                }
            }
        )
        
    },

    editSelection(item){
        if(item.selected ==1){
            this.selectedBackOrders.add(item.id)
            this.showAlert=false

        }else{
            this.selectedBackOrders.delete(item.id)
        }
    },

      convert(){
        let array = Array.from(this.selectedBackOrders);
        if(!array.length){
            this.showAlert=true
            return;
        }else{
            this.showAlert=false
        }

        Swal.fire({
            title: i18n.t('cartTab.swal.title'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f46a6a",
            cancelButtonColor: "#34c38f",
            cancelButtonText: i18n.t('cartTab.swal.cancelButtonText'),
            confirmButtonText: i18n.t('cartTab.swal.confirmButtonText')
        }).then(
            result =>{
                if(result.value){
                    BackOrdersApi.convertToOrder(array).then(
                        (result)=>{
                            if(result){
                                this.findBackOrders()
                                this.order=result
                                this.showOrdersDetailsModal=true
                            }
                        }
                    )
                }
            }
        )

      },


    closeOrderModal(){
        this.showOrdersDetailsModal=false
        this.showAlert=false;
    }

  },
    watch: {
        selected: function() {
            this.selectedCustomer = this.selected ? this.selected.id : null
            this.findBackOrders()
        },
    }       
    }

</script>
<template>
      <div>
        <div  class="row mb-0 ">
            <div class="col-sm-4 col-xs-12 pr-4 " :class="role==0 ? 'pb-4' : ''">
                <b-form-group :label="$t('cartTab.filter')" >
                        <b-input-group>
                            <b-form-input :placeholder="$t('cartTab.reference')" v-model="refFilter"   @keyup.native.enter="findBackOrders()"
                                ></b-form-input>    
                            <template v-slot:append>
                                <b-button  variant="warning" @click="findBackOrders()">
                                <i class="bx bx-search-alt  font-weight-bold font-size-16 text-primary align-middle"></i>
                                </b-button>
                            </template>                            
                        </b-input-group>
                </b-form-group>
            </div>
            <div class="col-sm-4"/>
            <div v-if="role==1" class="col-sm-4 col-xs-12  ">
                <b-form-group :label="$t('lists.customers.filter')" label-for="">
                    <v-select class="style-vselect font-size-16"  :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selected">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>
            <div v-if="role==0" class="col-sm-4 col-xs-12 mt-sm-4 pb-4 pb-xl-0 pb-lg-0">
                    <b-button @click="convert()" variant="light" class="float-right ">
                        <i class="fas fa-retweet text-primary font-size-16 align-middle mr-2"></i>
                        <span class="font-weight-bold text-primary text-uppercase"> {{$t('cartTab.convertButton')}}</span>
                    </b-button> 
            </div>
        </div>

        <b-alert :show="role==0 && showAlert"  variant="danger" class="w-50 d-none d-lg-block">
            <i class="fas fa-exclamation-triangle mr-2"></i>{{$t('cartTab.alertButton')}}
        </b-alert>

        <b-alert :show="role==0 && showAlert"  variant="danger" class="w-100 mt-4 d-block d-lg-none">
            <i class="fas fa-exclamation-triangle mr-2"></i>{{$t('cartTab.alertButton')}}
        </b-alert>
           
        <div class="table-responsive">        
        <b-table 
        :striped="true"
        :small="false"
        :hover="true"
        :busy="isTableLoading"
        :items="itemsList"
        :fields="role==0 ? itemsListFieldsForCustomer :   hasBackOrderCancelAccess || isAdmin ?  itemsListFieldsForSupplier : []"
        :perPage="pagemodel.perPage"
        class="table  "
        >
        <template v-slot:head(creationDateStr)>
            {{ $t("cartTab.listFields.addToBackOrderDate") }} 
        </template>
        <template v-slot:head(customerName)>
            {{ $t("cartTab.listFields.customerName") }} 
        </template>
        <template v-slot:head(itemRef)>
            {{ $t("cartTab.listFields.ref") }} 
        </template>
        <template v-slot:head(itemTitle)>
            {{ $t("cartTab.listFields.itemTitle") }} 
        </template>
        <template v-slot:head(quantity)>
            {{ $t("cartTab.listFields.backOrderQantity") }} 
        </template>
        <template v-slot:head(discountedPrice)>
            {{ $t("cartTab.listFields.discountedPrice") }} 
        </template>
        <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
        </template>
        <template v-slot:cell(selection)="{item}">
              <b-form-checkbox
                value="1"
                unchecked-value="0"
                class="custom-checkbox-success mb-3"
                v-model="item.selected"
                @input="editSelection(item)"
                ></b-form-checkbox
                >
        </template>
        <template v-slot:cell(quantity)="{item}">
            <div v-if="role==0">
                <div v-show="!item.edit" @click="editBackOrderQuantity(item)" >
                    {{ item.quantity}} 
                    <i  class="fas fa-edit font-size-16 ml-2"  style="cursor:pointer" :title="$t('cartTab.editQuantity')"></i>
                </div>
                <div class="input-group input-group-sm pull-right mb-0" style="width:10em;float:right" v-show="item.edit"   >
                    <b-form-input
                     min=1 v-model="item.quantity" :ref="'confirmedQuantityEdit-'+item.id" type="number"  
                    size="sm" class="no-shadow p-1" @keyup.native.enter="saveBackOrderQuantity(item)" @blur="saveBackOrderQuantity(item)"></b-form-input>
                        <div class="input-group-append"  size="sm" >
                        <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="saveBackOrderQuantity(item)" ><i  class="fas fa-edit font-size-14"></i></b-button>
                        </div>
                </div>
            </div>
            
            <div v-if="role==1">
                {{ item.quantity }} 
            </div>

        </template>
        <template v-slot:cell(action)="{item}">
            <b-button @click="cancelBackOrder(item)"  size="sm" variant="outline-danger" >
                  <i class="fas fa-times font-size-16 align-middle mr-2"></i>{{$t("buttons.cancel")}}
            </b-button> 
        </template>
        </b-table>
        <span v-if="!isTableLoading && !itemsList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('cartTab.tabEmpty')}}</span>
        </div>

        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="findBackOrders()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findBackOrders()" :disabled="isTableLoading" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->

        <b-modal
        v-if="order.id"
        v-model="showOrdersDetailsModal"
        :title="$t('ordersDetailsModal.title')"
        centered 
        title-class="text-primary"
        title-tag="h5"
        header-close-variant="danger"
        class="modal-fullscreen"
        size="xl"
        full-screen
        no-close-on-esc
        hide-footer
        >
            <OrderModal :orderId="this.order.id" v-on:update="closeOrderModal" />
        </b-modal>
      </div>

</template>